import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';

import { makeSelectAttributeValue } from './selectors';

interface Props {
    schemaAttributeId: number; // eslint-disable-line
    documentSetId: number; // eslint-disable-line
}

export default function JobAttributeValue(props: Props): React.ReactElement {
    const value = useSelector((state: AppState) =>
        makeSelectAttributeValue()(state, props)
    );

    return <React.Fragment>{value}</React.Fragment>;
}
